// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4840) return "static/chunks/bab91655-c0fe1288c621dc8f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"74454d4c87909dbe","669":"e78dd8e73720f5e7","2054":"c8d201eb4e0633a1","4747":"33000e3d07224bc9","4771":"71afa9f89d16eaae","5894":"54d41389c149423f","6407":"09a700e6a67371a9","8274":"dc3dad54ecedb141","8964":"35b809e6e5f46874"}[chunkId] + ".js";
};